import { render, staticRenderFns } from "./channelCofiiguration.vue?vue&type=template&id=081edc46&scoped=true"
import script from "./channelCofiiguration.vue?vue&type=script&lang=js"
export * from "./channelCofiiguration.vue?vue&type=script&lang=js"
import style0 from "./channelCofiiguration.vue?vue&type=style&index=0&id=081edc46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081edc46",
  null
  
)

export default component.exports